export default __webpack_public_path__ + "cb5b5222e5d78cb4341ed24b82d0de46.svg";